/*
Actions framework
*/

jQuery(document).ready(function() {

    jQuery('.filter-by-framework').html('<ul class="filter--choices-af"><li class="filter--choice-af assets on">Assets</li><li class="filter--choice-af programmes">Programmes</li><li class="filter--choice-af institutions">Institutions</li></ul>');

    var chosenFramework;
    // When the filter choice is clicked...
    jQuery('.filter--choice-af').click(function(){
        jQuery('.filter--choice-af').removeClass('on');
        jQuery(this).addClass('on');
        // We set a variable and...
        chosenFramework = jQuery(this).attr('class').split(' ')[1];
        // Change the box heading
        jQuery('.actions-framework-group-title').text(chosenFramework);
        jQuery('.actions-framework-group').removeClass('assets programmes institutions');
        jQuery('.actions-framework-group').addClass(chosenFramework);
    });

    // If an aspiration title is clicked we... 
	jQuery('.aspiration-title').click(function(){
    // (1) hide any previously shown content and...
		jQuery('.aspiration-title').removeClass('on');
        // (2) show the content for the newly clicked title
		jQuery(this).addClass('on');
    });
}); 